<template>
  <div class="">
    <BannerClient2 />
    <div class="home-content">
      <div id="content">
        <div class="home">
          <div class="about">
            <div class="wrapper">
              <div class="inner">
                <div class="main">
                  <ul class="list">
                    <li class="title">
                      <h2>About SourcedOut</h2>
                    </li>
                    <li class="text">
                      <p>
                        <span>“SourcedOut”</span> is the best digital recruiting
                        platform to look for tech talents for your company where
                        you can directly connect with 50+ professional tech
                        recruiters instead of traditional recruitment agencies
                        in the market.
                      </p>
                    </li>
                    <li class="cta-button">
                      <a href="/" class="btn btn-blue"
                        >Send your job request!</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="benefit">
            <div class="wrapper">
              <div class="inner">
                <div class="main">
                  <ul class="list">
                    <li class="title">
                      <h2>Why Choose SourcedOut?</h2>
                    </li>
                    <li class="benefit-container">
                      <ul class="list">
                        <li class="item">
                          <div class="icon">
                            <img
                              src="@/images/views/client/home/benefit-1.png"
                              alt="Earn Extra Income"
                            />
                          </div>
                          <div class="heading">
                            <h2>Cost Effectiveness</h2>
                          </div>
                          <div class="text">
                            <h3>
                              <b>50% lower </b> recruiment costing compared with
                              most recruitment agencies. No hiring, No fees, No
                              risk !
                            </h3>
                          </div>
                        </li>
                        <li class="item">
                          <div class="icon">
                            <img
                              src="@/images/views/client/home/benefit-2.png"
                              alt="Earn Extra Income"
                            />
                          </div>
                          <div class="heading">
                            <h2>Qualified Applicants</h2>
                          </div>
                          <div class="text">
                            <h3>
                              Expand your limited candidate pool through our
                              platform connecting with professional recruiters
                              specialized in your industry and business!
                            </h3>
                          </div>
                        </li>
                        <li class="item">
                          <div class="icon">
                            <img
                              src="@/images/views/client/home/benefit-3.png"
                              alt="Earn Extra Income"
                            />
                          </div>
                          <div class="heading">
                            <h2>Time Sufficiency</h2>
                          </div>
                          <div class="text">
                            <h3>
                              Start recruiting by only sending job request!
                            </h3>
                            <h3>
                              Connect professioanl recruiters in the market
                              right away!
                            </h3>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="compare">
            <div class="wrapper">
              <div class="inner">
                <div class="main">
                  <ul class="list">
                    <li class="title">
                      <h2>Best Value for Your Recruiting Budget</h2>
                    </li>
                    <li class="compare-table table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th></th>
                            <th class="hilight img-top">
                              <img
                                class="sourcedout-logo"
                                src="@/images/views/client/home/so-logo.png"
                              />
                            </th>
                            <th>Recruitment Agency</th>
                            <th>Job Ads</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="heading">Quality of Applicants</td>
                            <td class="hilight">
                              <b>High</b> (Screened by professional recruiters)
                            </td>
                            <td>High (Screened by professional recruiters)</td>
                            <td>Low (No screening)</td>
                          </tr>
                          <tr>
                            <td class="heading">Cost</td>
                            <td class="hilight"><b>10% of annual salary</b></td>
                            <td>20-30% of annual salary</td>
                            <td>5,000~20,000 baht / Job</td>
                          </tr>
                          <tr>
                            <td class="heading">
                              Number of Professional Tech Recruiters
                            </td>
                            <td class="hilight"><b>50+</b></td>
                            <td>0-5</td>
                            <td>None</td>
                          </tr>
                          <tr>
                            <td class="heading">Recruiters</td>
                            <td class="hilight">
                              <b>Professional HR recruiters network</b>
                            </td>
                            <td>Professional Recruiters</td>
                            <td>None</td>
                          </tr>
                          <tr>
                            <td class="heading">Time Efficiency upon hiring</td>
                            <td class="hilight"><b>Fast</b></td>
                            <td>Fast</td>
                            <td>Slow</td>
                          </tr>
                          <tr>
                            <td class="heading">Sourcing</td>
                            <td class="hilight">
                              <b>(Active)</b> approch to candidate with best
                              match job qualification
                            </td>
                            <td>
                              (Active) approch to candidate with best match job
                              qualification
                            </td>
                            <td>
                              (Passive) waiting for random applicant to apply
                              their resume
                            </td>
                          </tr>
                          <tr>
                            <td class="heading">
                              Hiring Assistance (Reduce HR tasks)
                            </td>
                            <td class="hilight">
                              - Job requirement and posting<br />
                              - Candidate screening with job qualification<br />
                              - Interview arrangement and process<br />
                              - Job offering
                            </td>
                            <td>
                              - Job requirement and posting<br />
                              - Candidate screening with job qualification<br />
                              - Interview arrangement and process<br />
                              - Job offering
                            </td>
                            <td>None</td>
                          </tr>
                          <tr>
                            <td class="heading">Service Payment</td>
                            <td class="hilight last">
                              <b>No hiring, no fees</b>
                            </td>
                            <td>No hiring, no fees</td>
                            <td>Advance paid for service</td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  </ul>
                  <div class="cta-button">
                    <a href="/" class="btn btn-blue"
                      >No hiring, no fees. Send job request today!</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import BannerClient2 from "@/components/views/client/BannerClient2";
import Footer from "@/components/layouts/Footer";
export default {
  name: "Index",
  components: {
    BannerClient2,
    Footer,
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.home {
  .inner {
    padding: 5rem 0;
  }
  .title {
    h2 {
      text-align: center;
      font-size: 2em;
    }
  }
  .about {
    .list {
      justify-content: center;
      text-align: center;

      & > * {
        margin-bottom: 1.5rem;
      }

      & > *:last-child {
        margin-bottom: 0;
      }

      .text {
        p {
          font-size: 1.5em;
          font-weight: 500;
          line-height: 2.5rem;
          margin: auto;
          padding: 3rem 0;
          width: 80%;

          span {
            font-weight: 700;
          }
        }
      }

      .cta-button {
        text-align: center;
        margin-top: 1rem;
        .btn {
          display: inline-flex;
          font-size: 1.2em;
          font-weight: 500;
          margin: auto;
          padding: 1rem 1.75rem;
          white-space: normal;
        }
      }
    }
  }
  .benefit {
    background: #001ee2;

    .list {
      text-align: center;

      & > * {
        margin-bottom: 1.5rem;
      }

      & > *:last-child {
        margin-bottom: 0;
      }

      .title {
        h2 {
          color: $white;
        }
      }

      .benefit-container {
        .list {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          padding: 1rem 0;

          .item {
            align-items: center;
            display: flex;
            flex-direction: column;
            justify-content: baseline;
            margin-bottom: 1rem;
            padding: 2rem 1rem;
            width: 33.33%;

            & > * {
              margin-bottom: 1rem;
            }

            & > *:last-child {
              margin-bottom: 0;
            }

            .icon {
              background: rgba(0, 0, 0, 0.2);
              border-radius: 100rem;
              height: 200px;
              position: relative;
              width: 200px;

              img {
                height: auto;
                left: 50%;
                position: absolute;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 145px;
              }
            }

            .heading {
              h2 {
                color: $white;
                font-size: 1.5em;
                /* stylelint-disable, declaration-no-important */
                font-weight: 500 !important;
                /* stylelint-enable, declaration-no-important */
                letter-spacing: 1px;
              }
            }

            .text {
              h3 {
                color: $white;
                font-size: 1.2em;
                /* stylelint-disable, declaration-no-important */
                font-weight: 400 !important;
                /* stylelint-enable, declaration-no-important */
                line-height: normal;
                margin-bottom: 0.5rem;
                opacity: 0.8;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  //table
  .compare {
    .compare-table {
      padding: 4rem 0;
      table {
        border: 0;
        color: $black;
        th {
          border: none;
          background: none;
          color: $black;
          font-weight: bold;
        }
        th,
        td {
          padding: 15px 20px;
        }
        th.img-top {
          padding-top: 30px;
        }
        .sourcedout-logo {
          width: 180px;
          margin: 0 auto;
        }
        td.heading {
          font-weight: 700;
        }
        .hilight {
          background: #001ee20f;
        }
        .last {
          padding-bottom: 2rem;
        }
      }
    }
    .cta-button {
      text-align: center;
      margin-top: 1rem;
      .btn {
        display: inline-flex;
        font-size: 1.2em;
        font-weight: 500;
        margin: auto;
        padding: 1rem 1.75rem;
        white-space: normal;
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .home {
    .inner {
      padding: 4rem 20px;
    }
    .title {
      h2 {
        font-size: 1.75em;
      }
    }
    .about {
      .list {
        .text {
          p {
            font-size: 1.2em;
            line-height: 2rem;
            margin: auto;
            padding: 1rem 0;
            width: 100%;
          }
        }
        .cta-button {
          .btn {
            display: flex;
            font-size: 1em;
            font-weight: 500;
            margin: auto;
            padding: 15px 15px;
          }
        }
      }
    }

    .benefit {
      .list {
        & > * {
          margin-bottom: 1rem;
        }

        .benefit-container {
          .list {
            display: flex;
            flex-direction: column;
            padding: 1rem 0;

            .item {
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: baseline;
              margin-bottom: 1rem;
              padding: 0.5rem 0;
              width: 100%;

              & > * {
                margin-bottom: 1rem;
              }

              .icon {
                height: 150px;
                width: 150px;

                img {
                  width: 110px;
                }
              }

              .heading {
                h2 {
                  font-size: 1.5em;
                }
              }

              .text {
                h3 {
                  font-size: 1em;
                }
              }
            }
          }
        }

        .button {
          width: 100%;

          .btn {
            display: block;
            font-size: 1em;
            padding: 1rem 1.5rem;
          }
        }
      }
    }
    .compare {
      .compare-table {
        padding: 2rem 0;
        table {
          th {
            font-size: 14px;
            line-height: 1rem;
          }
          th,
          td {
            padding: 5px 10px;
            font-size: 10px;
            line-height: 1rem;
          }
          th.img-top {
            padding-top: 20px;
          }
          .sourcedout-logo {
            width: 120px;
          }
          td.heading {
            font-weight: 700;
          }
          .hilight {
            background: #001ee20f;
          }
          .last {
            padding-bottom: 2rem;
          }
        }
      }
      .cta-button {
        .btn {
          display: flex;
          font-size: 1em;
          font-weight: 500;
          margin: auto;
          padding: 15px 15px;
        }
      }
    }
  }
}
</style>
